import { ButtonVariant } from '@/shared/components/Buttons';
import type { UpdateStatusDialogProps } from '@/epics/adminManagment/pages/adminList/UpdateStatusDialog';
import { AdminStatusSwitchIcon } from '@/epics/adminManagment/pages/adminList/AdminStatusDialogContent';

export type EmployeeStatusDialogConfig = Pick<
  UpdateStatusDialogProps,
  | 'title'
  | 'content'
  | 'confirmButtonLabel'
  | 'confirmButtonLabelLoading'
  | 'icon'
  | 'confirmButtonVariant'
>;

export function getEmployeeStatusDialogConfig(
  employeeName: string,
  isActive: boolean
): EmployeeStatusDialogConfig {
  const isActivating = !isActive;
  return {
    title: isActivating ? 'Activate Employee?' : 'Deactivate Employee?',
    content: (
      <>
        <span>
          {isActivating
            ? 'Are you sure you want to activate '
            : 'Are you sure you want to deactivate '}
        </span>
        <span className="font-medium">{employeeName}</span>
        <span>?</span>
      </>
    ),
    confirmButtonLabel: isActivating ? 'Aktywuj' : 'Dezaktywuj',
    confirmButtonLabelLoading: isActivating
      ? 'Aktywowanie…'
      : 'Dezaktywowanie…',
    icon: <AdminStatusSwitchIcon isActivating={isActivating} />,
    confirmButtonVariant: isActivating
      ? ButtonVariant.Success
      : ButtonVariant.Error,
  };
}
